// The six real stages of the recon scan→STEP pipeline (Stage 0-5), surfaced to
// the UI so the generation progress bar reflects the ACTUAL stage the
// reconstruction is in — not a timer. The backend job reports one of these keys
// plus an overall 0–1 fraction.

export const SCAN_STAGES = [
  { key: 'ingest', label: 'Ingest & triage' },
  { key: 'cleanup', label: 'Cleanup' },
  { key: 'segment', label: 'Region proposal' },
  { key: 'fit', label: 'Fitting tournament' },
  { key: 'constraints', label: 'Constraint discovery' },
  { key: 'assemble', label: 'Assemble & STEP export' },
] as const;

export type ScanStageKey = (typeof SCAN_STAGES)[number]['key'];

export const SCAN_STAGE_KEYS = SCAN_STAGES.map((s) => s.key) as ScanStageKey[];

export function stageIndex(key: ScanStageKey | null): number {
  if (key == null) return -1;
  return SCAN_STAGE_KEYS.indexOf(key);
}

export function stageLabel(key: ScanStageKey | null): string {
  const s = SCAN_STAGES.find((x) => x.key === key);
  return s ? s.label : '';
}
